import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";

import { modalGridColDefs } from "../constants/modalGridColDefs";

interface PaymentConfirmationGridProps {
  milestones: any[]; // Keep as any[] to avoid AG Grid type conflicts with flexible column definitions
  height?: number;
}

export const PaymentConfirmationGrid = ({
  milestones,
  height = 300,
}: PaymentConfirmationGridProps) => {
  const staticGridProps = useMemo(
    () => ({
      columnDefs: modalGridColDefs,
      // Disable all interactive features
      suppressRowSelection: true,
      suppressRowClickSelection: true,
      suppressCellSelection: true,
      suppressMovableColumns: true,
      suppressSorting: true,
      suppressFilter: true,
      suppressQuickFilterRow: true,
      suppressColumnFilter: true,
      suppressMenuHide: true,
      suppressRowHoverHighlight: true,
      // Grid sizing
      rowHeight: 35,
      headerHeight: 40,
      // Disable features
      defaultColDef: {
        sortable: false,
        filter: false,
        menuTabs: [],
      },
      // Styling
      rowClass: "payment-confirmation-row",
      headerClass: "payment-confirmation-header",
    }),
    [],
  );

  return (
    <div
      className="ag-theme-alpine payment-confirmation-grid"
      style={{ height: `${height}px`, width: "100%" }}
    >
      <AgGridReact {...staticGridProps} rowData={milestones} />
    </div>
  );
};
